import { UserRole } from '@socium/sociumflow';
import { RoutesValues } from '../../common/enums/routes.enum';
import { TranslateKey } from '../../features/translations/enums/translate-key.enum';
import { ComplianceTranslateKey } from '../../routes/compliances/models/compliance-translate-key.enum';
import { AppMenuItem } from './sidebar-model';

export const adminMenu: AppMenuItem[] = [
  {
    items: [
      {
        label: TranslateKey.DASHBOARD_TITLE,
        icon: 'uil uil-estate text-2xl',
        routerLink: [`/${RoutesValues.HOME}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.REQUESTS_TITLE,
        icon: 'uil uil-file-landscape-alt text-2xl',
        routerLink: [`/${RoutesValues.DOCUMENT_REQUESTS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.CONTRACTS_TITLE,
        icon: 'uil uil-file-shield-alt text-2xl',
        routerLink: [`/${RoutesValues.CONTRACTS}/${RoutesValues.FOLDERS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.MODELS_TITLE,
        icon: 'uil uil-folder text-2xl',
        routerLink: [`/${RoutesValues.MODELS}/${RoutesValues.FOLDERS}/`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.EMPLOYEES_TITLE,
        icon: 'uil uil-users-alt text-2xl',
        routerLink: [`/${RoutesValues.EMPLOYEES}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: ComplianceTranslateKey.DOCUMENTARY_COMPLIANCE_SHORT,
        icon: 'uil uil-book-alt text-2xl',
        routerLink: [`/${RoutesValues.COMPLIANCES}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.PAYSLIP_TITLE,
        icon: 'uil uil-receipt text-2xl',
        routerLink: [`/${RoutesValues.PAYSLIPS}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
      {
        label: TranslateKey.SETTINGS_TITLE,
        icon: 'uil uil-setting text-2xl',
        routerLink: [`/${RoutesValues.SETTINGS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
    ],
  },
];

export const employeeMenu: AppMenuItem[] = [
  {
    items: [
      {
        label: TranslateKey.CONTRACTS_TITLE,
        icon: 'uil uil-file-shield-alt text-2xl',
        routerLink: [`/${RoutesValues.CONTRACTS}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
      {
        label: TranslateKey.REQUESTS_TITLE,
        icon: 'uil uil-file-landscape-alt text-2xl',
        routerLink: [`/${RoutesValues.DOCUMENT_REQUESTS}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
      {
        label: TranslateKey.PAYSLIP_TITLE,
        icon: 'uil uil-receipt text-2xl',
        routerLink: [`/${RoutesValues.PAYSLIPS}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
      {
        label: TranslateKey.PROFILE_TITLE,
        icon: 'uil uil-user-circle text-2xl',
        routerLink: [`/${RoutesValues.PROFILE}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
    ],
  },
];

export const sociumAdminMenu: AppMenuItem[] = [
  {
    items: [
      {
        label: TranslateKey.DASHBOARD_TITLE,
        icon: 'uil uil-estate text-2xl',
        routerLink: [`/${RoutesValues.HOME}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.REQUESTS_TITLE,
        icon: 'uil uil-file-landscape-alt text-2xl',
        routerLink: [`/${RoutesValues.DOCUMENT_REQUESTS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.CONTRACTS_TITLE,
        icon: 'uil uil-file-shield-alt text-2xl',
        routerLink: [`/${RoutesValues.CONTRACTS}/${RoutesValues.FOLDERS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.MODELS_TITLE,
        icon: 'uil uil-folder text-2xl',
        routerLink: [`/${RoutesValues.MODELS}/${RoutesValues.FOLDERS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.EMPLOYEES_TITLE,
        icon: 'uil uil-users-alt text-2xl',
        routerLink: [`/${RoutesValues.EMPLOYEES}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: ComplianceTranslateKey.DOCUMENTARY_COMPLIANCE_SHORT,
        icon: 'uil uil-book-alt text-2xl',
        routerLink: [`/${RoutesValues.COMPLIANCES}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.PAYSLIP_TITLE,
        icon: 'uil uil-receipt text-2xl',
        routerLink: [`/${RoutesValues.PAYSLIPS}`],
        profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
      },
      {
        label: TranslateKey.SETTINGS_TITLE,
        icon: 'uil uil-setting text-2xl',
        routerLink: [`/${RoutesValues.SETTINGS}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
      {
        label: TranslateKey.COUNTRY_CONFIGURATION_TITLE,
        icon: 'uil uil-sliders-v-alt text-2xl',
        routerLink: [`/${RoutesValues.COUNTRY_CONFIG}`],
        profiles: [UserRole.HOLDING_ADMIN],
      },
    ],
  },
];
